<div
    class="identity-id-proofing-header"
    style="display: flex; justify-content: space-between; align-items: center">
    <div style="display: flex; align-items: center; gap: 10px">
        @if (showLeftLogo()) {
            <img
                [src]="logoUrl()"
                alt="Logo"
                style="max-height: 28px" />
        }
        <h2
            class="modal-title"
            style="white-space: nowrap">
            {{ actualHeaderTitle() }}
        </h2>
    </div>
    <img
        [src]="kno2ConnectedLogoUrl()"
        alt="Logo" />
</div>
